import React from "react";
import { useLang } from "../../lib/i18n";
import { Reveal } from "../motion/Reveal";

const SectionKicker = ({ children }) => (
  <div className="flex items-center gap-3 mb-5">
    <span className="h-px w-10 bg-emerald2" />
    <span className="text-emerald2 text-xs uppercase tracking-[0.3em] font-medium">{children}</span>
  </div>
);

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36" data-testid="manifesto">
      <Reveal>
        <SectionKicker>{t.manifesto.kicker}</SectionKicker>
        <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl max-w-4xl leading-[0.95]">
          {t.manifesto.title}
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-xl overflow-hidden">
        {t.manifesto.chapters.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.12}>
            <div className="group bg-charcoal hover:bg-[#202020] transition-colors duration-500 p-8 md:p-10 h-full">
              <span className="font-display text-6xl font-extrabold text-white/10 group-hover:text-emerald2 transition-colors duration-500">
                {c.n}
              </span>
              <h3 className="font-display text-2xl font-bold mt-6 mb-3">{c.t}</h3>
              <p className="text-white/60 leading-relaxed text-sm">{c.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export { SectionKicker };
